import { GetStaticPaths, GetStaticProps } from 'next';
import { getFooter, getHeader, getMenu, getPage, WagtailApiResponseError } from '@api/wagtail';
import LazyViews from '@views/LazyViews';
import { PageData } from '@/types';

const isProd = process.env.NODE_ENV === 'production';

interface Props {
  pageData: PageData;
}

function CatchAllPage(props: Props) {
  const { pageData } = props;

  const Component = LazyViews[pageData.meta.type];
  if (!Component) {
    return <h1>Component {pageData.meta.type} not found</h1>;
  }

  // @ts-expect-error
  return <Component {...pageData} />;
}

export default CatchAllPage;

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const newParams = params || {};
  let path: string | string[];
  if (Array.isArray(newParams.path)) {
    path = newParams.path;
  } else if (newParams.path) {
    path = [newParams.path];
  } else {
    path = [];
  }

  path = path.join('/');

  try {
    const [{ json: pageData }, { json: footerData }, { json: headerData }, { json: menuData }] =
      await Promise.all([getPage(path), getFooter(), getHeader(), getMenu()]);
    return {
      props: { pageData, footerData, headerData, menuData },
      revalidate: 3600,
    };
  } catch (err) {
    if (!(err instanceof WagtailApiResponseError)) {
      throw err;
    }

    if (!isProd && err.response.status >= 500) {
      const html = await err.response.text();
      return {
        props: {
          componentName: 'PureHtmlPage',
          componentProps: { html },
        },
      };
    }

    if (err.response.status >= 500) {
      throw err;
    }

    return { notFound: true };
  }
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});
